<template>
    <div class="com-codics-hbb-order-admin-shop-body">
        <div class="com-codics-hbb-order-admin-shop-bar-content">
            <el-cascader class="com-codics-hbb-order-admin-shop-bar-pick" v-model="goodsType" placeholder="请选择分类" filterable
                :options="typeOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-cascader class="com-codics-hbb-order-admin-shop-bar-pick" v-model="goodsBrand" placeholder="请选择品牌" filterable
                :options="brandOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-select v-model="goodsTag" multiple collapse-tags style="float:left;margin-right:15px;"
                placeholder="请选择标签" filterable clearable @change="listGoodssFuc">
                <el-option v-for="item in tagsOptions" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-shop-bar-input" v-model="searchTxt" placeholder="请输入商品信息..."
                clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="searchGoodss">&#xe86e;
            </MyButton>
            <MyButton style="float: right;" @click.native="jumpToWeb('https://www.haobangbang.cn/', '_blank')">&#xe6be;
                邦邦商城</MyButton>
            <!-- <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的商品数据（包括销售参数）吗？" @confirm="deleteGoodssFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
            <MyButton style="float: right;margin-right: 15px;padding:0 15px;">&#xe854;</MyButton> -->
        </div>
        <div class="com-codics-hbb-order-admin-shop-bar-content com-codics-hbb-order-admin-shop-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                ref="cartTable">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="com-codics-hbb-order-admin-shop-item-box" v-for="(item, index) in props.row.info"
                            :key="index">
                            <div class="com-codics-hbb-order-admin-shop-item-card">
                                <div class="com-codics-hbb-order-admin-shop-item-card-line">
                                    <el-image class="com-codics-hbb-order-admin-shop-item-card-line-img"
                                        :src="'https://cdn.bosscaigou.com/' + item.img"></el-image>
                                    <div class="com-codics-hbb-order-admin-shop-item-card-line-text"
                                        style="padding-right: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                        size="mini" :title="item.title">
                                        {{ item.title }}
                                        <el-tag style="position:absolute;margin: auto;top: 0;bottom: 0;right: 0;"
                                            size="mini"
                                            :type="item.inventory > 100 ? 'success' : (item.inventory > 50 ? '' : (item.inventory > 20 ? 'warning' : 'danger'))">库存：{{
                                            item.inventory }}</el-tag>
                                    </div>
                                    <div class="com-codics-hbb-order-admin-shop-item-card-line-text com-codics-hbb-order-admin-shop-item-card-line-text2"
                                        style="color: #666;">
                                        成本：￥{{ item.np }}
                                    </div>
                                    <div
                                        class="com-codics-hbb-order-admin-shop-item-card-line-text com-codics-hbb-order-admin-shop-item-card-line-text2">
                                    </div>
                                    <div class="com-codics-hbb-order-admin-shop-item-card-line-text com-codics-hbb-order-admin-shop-item-card-line-text2"
                                        style="width: fit-content;margin-top: 7.5px;">
                                        报价：</div><el-input-number
                                        style="margin-top: 7.5px;margin-left: 10px;float: left;" :min="item.np"
                                        :precision="2" :step="0.1" size="mini" v-model="item.dp"
                                        @change="handlePriceChange(item)"></el-input-number>
                                    <div style="height:38px;width: calc(100% - 318px);position: relative;float: left;">
                                    </div>
                                    <div class="com-codics-hbb-order-admin-shop-item-card-line-text com-codics-hbb-order-admin-shop-item-card-line-text2"
                                        style="width: fit-content;margin-top: 7.5px;float: left;">
                                        数量：</div>
                                    <el-input-number style="margin-top: 7.5px;margin-left: 10px;float: left;"
                                        size="mini" v-model="item.count" :min="0"
                                        :max="item.inventory"></el-input-number>
                                </div>
                                <div class="com-codics-hbb-order-admin-shop-item-card-line2">
                                    <span
                                        style="float:left;width:calc(100% - 105px);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                        :title="item.remark">备注:{{ item.remark
                                        }}</span>
                                    <MyButton size="small" slot="reference"
                                        @click.native="item.zcount = item.count; addCartFuc(item, 1)"
                                        style="padding:0 10px;float: right;margin-top: 6px;margin-right: 5px;">
                                        &#xe629; 加入购物车
                                    </MyButton>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80">
                </el-table-column>
                <el-table-column prop="title" label="商品名称" width="110">
                </el-table-column>
                <el-table-column prop="detail" label="商品介绍" width="150">
                </el-table-column>
                <el-table-column prop="himg" label="商品封面" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.himg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.himg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="dimg" label="详情图片" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.dimg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.dimg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="video" label="商品视频" width="90">
                    <template slot-scope="scope">
                        <el-button v-show="scope.row.video != ''" type="primary" size="mini"
                            @click="playVideo(scope.row.video)">播放</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="tip" label="购买须知" width="110">
                </el-table-column>
                <el-table-column prop="origin" label="产地" width="110">
                </el-table-column>
                <el-table-column prop="type" label="商品分类" width="110">
                    <template slot-scope="scope">
                        <el-tag disable-transitions size="mini">{{
                            scope.row?.type }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="70"
                    :filters="[{ text: '上架', value: 0 }, { text: '下架', value: 1 }]" :filter-method="stateFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.state == 0 ? '上架'
                            : '下架' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ts" label="包邮" width="70"
                    :filters="[{ text: '包邮', value: 0 }, { text: '不包邮', value: 1 }]" :filter-method="tsFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ts == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.state == 0 ? '包邮'
                            : '不包邮' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="tt" label="物流方式" width="80">
                    <template slot-scope="scope">
                        {{ wuliuType[scope.row.tt] }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="ctime" label="创建时间" width="180">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column> -->
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <MyButton size="small" style="float: right;margin-right: 10px;" slot="reference"
                            @click.native="buyThat(scope.row);">采购
                        </MyButton>
                        <MyButton size="small" style="float: right;margin-right: 10px;" slot="reference"
                            @click.native="jumpToWeb('https://d.haobangbang.cn/detail/' + scope.row.id, '_blank')">产品详情
                        </MyButton>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40, 100]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <el-badge :value="cartData.length" class="com-codics-hbb-order-admin-shop-car-btn">
            <el-button class="iconfont" type="success" round plain @click="shopDrawer = true;">&#xe7b7;
                我的购物车</el-button>
        </el-badge>
        <el-drawer title="我的购物车" :visible.sync="shopDrawer" :direction="cartDirection" :size="cartSize">
            <div class="com-codics-hbb-order-admin-shop-car-body"
                :style="{ '--showTxt': cartData.length == 0 ? 'block' : 'none' }">
                <div v-for="(item, index) in cartData" :key="index" class="com-codics-hbb-order-admin-shop-car-item">
                    <div class="com-codics-hbb-order-admin-shop-car-item-card">
                        <el-image class="com-codics-hbb-order-admin-shop-car-item-card-img"
                            :src="'https://cdn.bosscaigou.com/' + item.goodsInfo.img" :fit="fill"></el-image>
                        <div class="com-codics-hbb-order-admin-shop-car-item-card-content">
                            <div class="com-codics-hbb-order-admin-shop-car-item-card-content-title">{{ item.goods.title
                                }}
                            </div>
                            <div class="com-codics-hbb-order-admin-shop-car-item-card-content-info">{{
                                item.goodsInfo.title }}</div>
                            <div class="com-codics-hbb-order-admin-shop-car-item-card-content-price">
                                <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="top"
                                    width="230" trigger="hover">
                                    <el-form :model="form" label-width="80px">
                                        <el-form-item label="商品报价">
                                            <el-input-number size="small" v-model="item.dp" :min="item.goodsInfo.np"
                                                :precision="2" :step="0.1"
                                                @change="handlePriceChange(item)"></el-input-number>
                                        </el-form-item>
                                    </el-form>
                                    <span slot="reference" style="color: #FE6446;font-size: 16px;font-weight: bolder;">
                                        <span style="font-size: 11px;font-weight: unset;">￥</span>
                                        {{ item.dp }}
                                        <span style="font-size: 11px;font-weight: unset;">报价</span>&nbsp;
                                        <span style="color: #999;font-size: 11px;font-weight: unset;">
                                            ￥{{ item.goodsInfo.np }}
                                        </span>
                                    </span>
                                </el-popover>
                            </div>
                            <el-input-number class="com-codics-hbb-order-admin-shop-car-item-card-count" size="mini"
                                :min="0" :max="item.goodsInfo.inventory"
                                @change="(nowVal, oldVal) => handleCartCountChange(nowVal, oldVal, item)"
                                v-model="item.count"></el-input-number>
                        </div>
                    </div>
                </div>
                <img v-show="cartData.length == 0" class="com-codics-hbb-order-admin-shop-car-empty" title="购物车是空的"
                    src="https://cdn.bosscaigou.com/huayuan/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9.svg">
            </div>
            <div class="com-codics-hbb-order-mess-control"
                :style="{ width: cartDirection == 'btt' ? '100%' : '450px' }">
                <div class="com-codics-hbb-order-admin-shop-car-price-box">
                    <div class="com-codics-hbb-order-admin-shop-car-price-box-line">
                        <span slot="reference" style="color: #FE6446;font-size: 15px;font-weight: bolder;">
                            <span style="font-size: 11px;font-weight: unset;">￥</span>{{ cartPrice.toFixed(2) }} <span
                                style="font-size: 11px;">利润￥<span>{{ (cartPrice - costPrice).toFixed(2) }}</span></span>
                        </span>
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-shop-car-price-box-line com-codics-hbb-order-admin-shop-car-price-box-line2">
                        成本：￥{{ costPrice.toFixed(2) }} （不包含运费）
                    </div>
                </div>
                <MyButton size="small" type="danger" @click.native="gotoBaoJia"
                    style="position: relative;float: right;top: 50%;transform: translateY(-50%);margin-right: 10px;font-size: 11px;"
                    title="生成报价单，生成后购物车将清空！">
                    &#xe761; 生成报价单
                </MyButton>
                <el-popconfirm style="float: right;position: relative;top: 50%;" confirm-button-text='好的'
                    cancel-button-text='不用了' icon="el-icon-info" icon-color="red" @confirm="clearCartFuc"
                    title="这是一段内容确定删除吗？">
                    <MyButton size="small" slot="reference"
                        style="float: right;top: 50%;transform: translateY(-50%);margin-right: 10px;padding:0 10px;"
                        title="清空购物车">
                        &#xe703;
                    </MyButton>
                </el-popconfirm>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import { jumpTo } from '@/utils/myutils';
import { listGoods2, addCart, deleteCart, listCart, clearCart, listGoodsBrand2, listGoodsType, listTags, updatePrice } from '@/api';
export default {
    data() {
        return {
            cartDirection: 'rtl',
            cartSize: '450px',
            shopDrawer: false,
            tableData: [],
            searchData: [],
            selectData: [],
            cartData: [],
            roleData: [],
            memsList: [],
            typeOptions: [],
            brandOptions: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            goodsType: [],
            goodsBrand: [],
            tagsOptions: [],
            goodsTag: [],
            buyNum: 1,
            wuliuType: {
                'shunfeng': '顺丰快递',
                'zhongtong': '中通快递',
                'yuantong': '圆通快递',
                'shentong': '申通快递',
                'jtexpress': '极兔快递',
                'yunda': '韵达快递',
                'jd': '京东快递',
                'ems': '邮政快递',
                'qitafangshi': '其他方式'
            }
        }
    },
    mounted() {
        this.listGoodssFuc();
        this.listCartFuc();
        this.listGoodsBrandFuc();
        this.listGoodsTypeFuc();
        this.listTagsFuc();
        this.cartDirection = this.isMobileByScreen() ? 'btt' : 'rtl';
        this.cartSize = this.isMobileByScreen() ? 'calc(100% - 60px)' : '450px';
    },
    components: {
        MyButton
    },
    methods: {
        jumpToWeb(url, target) {
            window.open(url, target);
        },
        gotoBaoJia() {
            if (this.cartData.length < 1) {
                this.$message({
                    message: '购物车是空的！',
                    type: 'info'
                });
                return;
            }
            this.jumpToPage('报价单生成', {}, {});
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async clearCartFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await clearCart();

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '购物车已清空！',
                    type: 'success'
                });

                this.cartData = [];

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleCartCountChange(nowVal, oldVal, item) {

            if (nowVal == 0) {

                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    item.zcount = 0;
                    this.addCartFuc(item, 0);
                }).catch(() => {
                    item.count = oldVal;
                });

            } else {

                item.zcount = nowVal;

                this.addCartFuc(item, 0);

            }

        },
        async handlePriceChange(item) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await updatePrice({ id: item.id, price: item.dp });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '价格修改成功！',
                    type: 'success'
                });

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodssFuc();

        },
        isMobileByScreen() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            return isSmallScreen && isTouchDevice;
        },
        async listTagsFuc() {
            const data = await listTags();
            if (data.code == 200) {
                this.tagsOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand2();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async addCartFuc(item, type) {

            if (item.zcount == 0) { 
                this.$message.error("添加到购物车的数量不能为0！");
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addCart({ id: item.id, count: item.zcount, type: type });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: item.oid == null ? '加入购物车成功！' : '修改数量成功！',
                    type: 'success'
                });

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async listCartFuc() {

            const data = await listCart();

            if (data.code == 200) {

                this.cartData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        buyThat(row) {

            this.$refs.cartTable.toggleRowExpansion(row, true);

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods2({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goodsType.length == 0 ? 0 : this.goodsType[this.goodsType.length - 1],
                brand: this.goodsBrand.length == 0 ? 0 : this.goodsBrand[this.goodsBrand.length - 1],
                tags: this.goodsTag
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listGoodssFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listGoodssFuc();
        },
        handleTypeChange() {
            this.listGoodssFuc();
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        tsFilter(v, r, c) {

            return r.ts === v;

        },
    },
    computed: {
        cartPrice() {
            let price = 0;
            this.cartData.forEach(item => {
                price += (item.dp * item.count);
            });
            return price;
        },
        costPrice() {
            let price = 0;
            this.cartData.forEach(item => {
                price += (item.goodsInfo.np * item.count);
            });
            return price;
        }
    }
}
</script>

<style>
.com-codics-hbb-order-admin-shop-body {
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

.com-codics-hbb-order-admin-shop-car-btn {
    position: fixed !important;
    margin: auto;
    right: 30px;
    bottom: 30px;
    z-index: 999;
}

.com-codics-hbb-order-admin-shop-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-shop-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-shop-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-shop-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-shop-item-box {
    height: 220px;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
    display: flex;
}

.com-codics-hbb-order-admin-shop-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    transition: .3s;
    background: #F9F9F9;
    border: 1px solid #DDD;
    cursor: pointer;
}

.com-codics-hbb-order-admin-shop-item-card-line {
    height: 155px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
}

.com-codics-hbb-order-admin-shop-item-card-line::before {
    content: '';
    height: 1px;
    width: calc(100% - 20px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-shop-item-card-line-img {
    height: 95px;
    width: 95px;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
}

.com-codics-hbb-order-admin-shop-item-card-line-text {
    height: 30px;
    width: calc(100% - 95px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    transition: .3s;
    line-height: 30px;
    font-size: 11px;
    font-weight: bolder;
    color: #333;
}

.com-codics-hbb-order-admin-shop-item-card-line-text .el-tag {
    font-size: 9px;
}

.com-codics-hbb-order-admin-shop-item-card-line-text2 {
    height: 25px;
    width: calc(50% - 47.5px);
    line-height: 25px;
    color: #999;
}

.com-codics-hbb-order-admin-shop-item-card-line2 {
    height: 45px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 44px;
    font-size: 11px;
    font-weight: bolder;
    color: #666;
    padding-left: 10px;
    user-select: none;
}

.com-codics-hbb-order-admin-shop-item-card-more-btn {
    height: 35px;
    width: 35px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 35px;
    text-align: center;
    font-size: 11px;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.com-codics-hbb-order-admin-shop-item-card2 {
    border: 1px dashed #666;
    border-radius: 8px;
    transition: .3s;
    background: transparent;
    cursor: pointer;
}

.com-codics-hbb-order-admin-shop-item-card2::before,
.com-codics-hbb-order-admin-shop-item-card2::after {
    content: '';
    height: 1px;
    width: 25px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: .3s;
    background: #666;
}

.com-codics-hbb-order-admin-shop-item-card2::after {
    transform: rotate(90deg);
}

.com-codics-hbb-order-admin-shop-car-body {
    height: calc(100% - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 15px;
}

.com-codics-hbb-order-admin-shop-car-body::before {
    content: '购物车内空空如也';
    height: 50px;
    width: fit-content;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 120px;
    bottom: 0;
    font-size: 12px;
    color: #666;
    display: var(--showTxt);
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
}

.com-codics-hbb-order-admin-shop-car-empty {
    height: 130px;
    width: 130px;
    position: absolute !important;
    margin: auto;
    left: 0;
    right: 0;
    top: -100px;
    bottom: 0;
    transition: .3s;
    object-fit: fill;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-shop-car-item {
    height: 130px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 5px;
}

.com-codics-hbb-order-admin-shop-car-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    transition: .3s;
    background: #FEFEFE;
    border: 1px solid #F0F0F0;
}

.com-codics-hbb-order-admin-shop-car-item-card-img {
    height: 90px;
    width: 90px;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 10px;
}

.com-codics-hbb-order-admin-shop-car-item-card-content {
    height: 100%;
    width: calc(100% - 100px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px 0;
}

.com-codics-hbb-order-admin-shop-car-item-card-content-title {
    height: 23px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 10px;
    transition: .3s;
    line-height: 23px;
    font-size: 11px;
    font-weight: bolder;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.com-codics-hbb-order-admin-shop-car-item-card-content-info {
    height: 18px;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 5px;
    transition: .3s;
    line-height: 18px;
    font-size: 9px;
    font-weight: bolder;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #F0F0F0;
    border-radius: 5px;
    margin-left: 10px;
    margin-top: 10px;
}

.com-codics-hbb-order-admin-shop-car-item-card-content-price {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 10px;
    transition: .3s;
    line-height: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5px;
}

.com-codics-hbb-order-admin-shop-car-item-card-count {
    position: absolute !important;
    margin: auto;
    right: 10px;
    bottom: 10px;
    width: 100px !important;
}

.com-codics-hbb-order-admin-shop-car-price-box {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px 0 10px 10px;
}

.com-codics-hbb-order-admin-shop-car-price-box-line {
    height: 24px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 24px;
    font-size: 17px;
    font-weight: bolder;
    color: #FE6446;
}

.com-codics-hbb-order-admin-shop-car-price-box-line2 {
    height: 15px;
    line-height: 15px;
    font-size: 10px;
    color: #666;
    top: -3.5px;
    font-weight: unset !important;
    padding-left: 2px;
}
</style>